// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__L6I81","logo__icon":"Logo_logo__icon__gtwyo"};